// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"9ce0e2b6","351":"67fa857a","421":"157dde3d","443":"265be038","488":"c996f101","542":"c51664d0","614":"992d330c"}[chunkId] + ".chunk.js";
};